import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { convertIsoStringsToDateObjects } from '@shared/string-date-to-object';

export const SKIP_ISO_DATE_CONVERSION = new HttpContextToken<boolean>(() => false);

@Injectable()
export class IsoStringToDateObjectInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_ISO_DATE_CONVERSION)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          convertIsoStringsToDateObjects(event.body);
        }
      }),
    );
  }
}
